import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@pisaka/ui';
import {
  basePageUrl, faqPageUrl, fontCreatorPageUrl, offerPageUrl, oldBasePageUrl, privacyPageUrl, refundPageUrl, termsPageUrl
} from '../../../helpers/urls';

type PropsType = {
  isOpen: boolean;
  onClose: () => void;
  AuthContent?: ReactNode;
  StatsContent?: ReactNode;
};

export const SidebarComponent: FC<PropsType> = ({ isOpen, onClose, AuthContent, StatsContent }) => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="left" className="w-[280px] flex flex-col justify-between p-0">
        <div>
          <SheetHeader className="p-4 border-b">
            <SheetTitle className="text-left">
              {AuthContent}
            </SheetTitle>
          </SheetHeader>
          <nav className="flex flex-col">
            <a href={basePageUrl} onClick={onClose} className="block py-3 px-4 border-b border-gray-100 hover:bg-gray-50 text-sm">
              {t('sidebar.noteGenerator')}
            </a>
            <a href={oldBasePageUrl} onClick={onClose} className="block py-3 px-4 border-b border-gray-100 hover:bg-gray-50 text-sm">
              {t('sidebar.oldNoteGenerator')}
            </a>
            <a href={fontCreatorPageUrl} onClick={onClose} className="block px-4 py-3 border-b border-gray-100 hover:bg-gray-50 text-sm">
              {t('sidebar.fontGenerator')}
            </a>
            <a href={faqPageUrl} onClick={onClose} className="block px-4 py-3 border-b border-gray-100 hover:bg-gray-50 text-sm">
              {t('sidebar.faq')}
            </a>
            {!isEn && (
              <a href={offerPageUrl} onClick={onClose} className="block px-4 py-3 border-b border-gray-100 hover:bg-gray-50 text-sm">
                {t('sidebar.offer')}
              </a>
            )}
            {isEn && (
              <a href={termsPageUrl} onClick={onClose} className="block px-4 py-3 border-b border-gray-100 hover:bg-gray-50 text-sm">
                {t('sidebar.terms')}
              </a>
            )}
            <a href={privacyPageUrl} onClick={onClose} className="block px-4 py-3 border-b border-gray-100 hover:bg-gray-50 text-sm">
              {t('sidebar.privacy')}
            </a>
            <a href={refundPageUrl} onClick={onClose} className="block px-4 py-3 hover:bg-gray-50 text-sm">
              {t('sidebar.refund')}
            </a>
          </nav>
        </div>
        <div className="p-4">
          {StatsContent}
          <p className="text-sm text-gray-500 mb-2">{t('sidebar.socials')}</p>
          <a href="https://vk.com/pisaka.online" target="_blank" rel="noreferrer" className="text-sm text-blue-500 hover:underline">
            VK
          </a>
        </div>
      </SheetContent>
    </Sheet>
  );
};
